// components/DataSourcesPopupModal.jsx
import React from "react";
import {
  Modal,
  Box,
  Typography,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import GavelIcon from '@mui/icons-material/Gavel';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import HandshakeIcon from '@mui/icons-material/Handshake'; 
import Source from '@mui/icons-material/Source';
import Security from '@mui/icons-material/Security';
import Close from '@mui/icons-material/Close';

const DataSourcesPopupModal = ({ open, onClose }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          maxWidth: "700px",
          mx: "auto",
          my: 6,
          p: 4,
          borderRadius: 2,
          backgroundColor: "#fff",
          position: "relative",
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", top: 8, right: 8 }}
        >
          <Close />
        </IconButton>

        <Box display="flex" alignItems="center" gap={1} mb={2}>
          <Security sx={{ color: "var(--secondary-color)" }} />
          <Typography variant="h6" fontWeight="bold">
            Data Sources & Objectives
          </Typography>
        </Box>

        <Typography variant="body2" sx={{ mb: 2 }}>
          CivixThread uses trusted public data from government agencies, as well as data from our community of U.S. citizens.
          We verify identities to keep CivixThread a credible space for real civic participation.
        </Typography>

        <Divider sx={{ my: 2 }} />

        <Box mb={2}>
          <Box display="flex" alignItems="center" gap={1}>
            <Source sx={{ color: "var(--secondary-color)" }} />
            <Typography variant="subtitle1" fontWeight={600}>
              Data Sources
            </Typography>
          </Box>
          <ul style={{ paddingLeft: "1.5rem", marginTop: "0.5rem" }}>
            <li><strong>U.S. Census Bureau</strong> – Demographic and socioeconomic data.</li>
            <li><strong>Congress.gov</strong> – Legislative data and representative profiles.</li>
            <li><strong>FEC</strong> – Campaign finance and donor data.</li>
            <li><strong>CAWP</strong> – Gender representation statistics.</li> 
            <li><strong>Google Civic API</strong> – Provides localized information on upcoming elections based on a user's address.</li> 

          </ul>
        </Box>

        <Box mb={3}>
          <Box display="flex" alignItems="center" gap={1} mb={1}> 
            <Typography variant="subtitle1" fontWeight={600}>
              Our Objective with CivixThread Collected Data
            </Typography>
          </Box>

          <List dense>
            <ListItem>
              <ListItemIcon>
                <RecordVoiceOverIcon sx={{ color: 'var(--secondary-color)' }} />
              </ListItemIcon>
              <ListItemText primary="Surface the issues citizens care about most by aggregating support and sentiment data from verified users." />
            </ListItem>

            <ListItem>
              <ListItemIcon>
                <GavelIcon sx={{ color: 'var(--secondary-color)' }} />
              </ListItemIcon>
              <ListItemText primary="Show representatives which bills their constituents support or oppose, based on real-time engagement." />
            </ListItem>

            <ListItem>
              <ListItemIcon>
                <LightbulbIcon sx={{ color: 'var(--secondary-color)' }} />
              </ListItemIcon>
              <ListItemText primary="Reveal gaps in representation by comparing constituent feedback to legislative voting records." />
            </ListItem>

            <ListItem>
              <ListItemIcon>
                <HandshakeIcon sx={{ color: 'var(--secondary-color)' }} />
              </ListItemIcon>
              <ListItemText primary="Strengthen connection between representatives and constituents." />
            </ListItem>
          </List> 
        </Box>

        
        <Typography variant="caption" color="text.secondary">
          Last updated: May 2025
        </Typography>
      </Box>
    </Modal>
  );
};

export default DataSourcesPopupModal;